// Same ASCII-only pattern as services `EMAIL_REGEX` (EmailUtils): Firebase Auth
// and our backend reject non-ASCII local parts / domains (ñ, accents, IDN, …).
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isValidEmail = (value: string): boolean => EMAIL_REGEX.test(value);
